/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

/*@ngInject*/
export default function TektelicMissingTranslateHandler($log, types) {

    return function (translationId) {
        if (translationId && !translationId.startsWith(types.translate.customTranslationsPrefix)) {
            $log.warn('Translation for ' + translationId + ' doesn\'t exist');
        }
    };

}



// WEBPACK FOOTER //
// ./src/app/locale/translate-handler.js